// OTTO EU

import React, { Component } from 'react';
import { Button, Row, Col, Collapse } from 'reactstrap';
import { debounce } from 'lodash';
import * as moment from 'moment';
import AddIcon from '../../../Icons/AddIcon';
import AuditLogModal from '../../../AuditLogModal';
import CaretToggle from '../../../Icons/CaretToggle';
import ColumnHelpers from '../../../ColumnHelpers';
import Help from '../../../HtmlHelpers';
import ListFunctions from '../../../FunctionsList';
import PageTitle from '../../../Layout/PageTitle';
import TableTitle from '../../../Layout/TableTitle';
import UserGroups from '../../../UserGroups';
import WmAuth from '../../../WmAuth';
import WmReactTable from '../../../Layout/WmReactTable';
import WmReactTableServerSide from '../../../Layout/WmReactTableServerSide';
const Moment = moment;
export default class CrudListContainerBase extends Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    this.isAddAdmin = () => WmAuth.isAddAdmin(this.state, this.getAddGroups());
    this.isEditAdmin = () => WmAuth.isEditAdmin(this.state, this.getEditGroups());
    this.getTableClassSettings = () => '';
    this.expandTitle = () => false;
    this.removeRow = uuid => this.setState(prevState => {
      const newStateData = prevState.data.filter(order => order.uuid !== uuid);
      return {
        data: newStateData
      };
    });
    this.handleResponse = function (response, msg) {
      let afterAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
      if (response.data !== undefined) {
        afterAction();
        _this.props.alert.show(msg, {
          type: 'success'
        });
      } else if (response.errors !== undefined) {
        const errors = Help.convertRailsErrors(response.errors);
        _this.props.alert.show(errors.join(', '), {
          type: 'error'
        });
      } else {
        _this.props.alert.show('System error, please try again. If you continue to get this error, open a Help Desk ticket', {
          type: 'error'
        });
      }
    };
    this.getCaretToggle = () => /*#__PURE__*/React.createElement(CaretToggle, {
      onClick: () => this.setState(prevState => ({
        tableOpen: !prevState.tableOpen
      })),
      open: this.state.tableOpen
    });
    this.getTitle = type => {
      let content = '';
      if (type === 'table') {
        content = /*#__PURE__*/React.createElement(TableTitle, {
          title: this.getPageTitle(),
          additional: this.getCaretToggle()
        });
      } else {
        content = /*#__PURE__*/React.createElement(PageTitle, {
          title: this.getPageTitle(),
          subtitle: this.getPageSubtitle()
        });
      }
      return content;
    };
    this.smallTitle = function () {
      let caret = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: "8",
        className: "text-left"
      }, caret ? _this.getTitle('table') : _this.getTitle('page')), /*#__PURE__*/React.createElement(Col, {
        md: "4",
        className: "align-self-center text-right"
      }, _this.isAddAdmin() ? _this.createButton() : ''));
    };
    this.getExpandedTitle = function () {
      let caret = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: "12",
        className: "text-left"
      }, caret ? _this.getTitle('table') : _this.getTitle('page'))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: "8",
        className: "text-left"
      }), /*#__PURE__*/React.createElement(Col, {
        md: "4",
        className: "align-self-center text-right"
      }, _this.isAddAdmin() ? _this.createButton() : '')));
    };
    this.expandedTitle = () => false;
    this.getContent = () => this.contentNotCollapsible();
    this.contentNotCollapsible = () => /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative',
        zIndex: '10'
      }
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "col-md-".concat(this.getWidthLeft())
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-md-".concat(this.getWidthCenter())
    }, this.expandTitle() ? this.getExpandedTitle(false) : this.smallTitle(false), this.indexTable()), /*#__PURE__*/React.createElement("div", {
      className: "col-md-".concat(this.getWidthRight())
    })), this.additionalContent(), this.itemForm(), this.auditLogModal());
    this.contentCollapsible = () => /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative',
        zIndex: '10'
      }
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "col-md-".concat(this.getWidthLeft())
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-md-".concat(this.getWidthCenter())
    }, this.expandTitle() ? this.getExpandedTitle(true) : this.smallTitle(true), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: this.state.tableOpen
    }, this.indexTable())), /*#__PURE__*/React.createElement("div", {
      className: "col-md-".concat(this.getWidthRight())
    })), this.additionalContent(), this.itemForm(), this.auditLogModal());
    this.getList = () => this.fetchData();
    this.fetchDataOptions = tableState => ({
      params: this.getListParams(),
      tableState,
      auth: this.props.auth,
      listApi: this.getListApi(),
      apiVersion: this.getApiVersion(),
      queryName: this.getQueryName(),
      sendAsData: this.sendAsData(),
      storageName: this.getStorageName(),
      innerTableRef: this.innerTableRef && this.innerTableRef.current ? this.innerTableRef.current : undefined,
      tableRef: this.tableRef && this.tableRef.current ? this.tableRef.current : undefined
    });
    this.fetchData = async () => {
      this.setState({
        loading: true,
        data: []
      });
      const data = await ListFunctions.fetchData(this.fetchDataOptions());
      this.setState(data);
    };
    this.fetchCsvData = async () => {
      this.setState({
        currentlyDownloading: true
      });
      const options = this.fetchDataOptions();
      options.params.show_all = 'true';
      let data;
      if (options.tableRef && options.tableRef instanceof WmReactTable) {
        data = {
          data: options.tableRef.reactTable.getResolvedState().sortedData.map(option => option._original)
        };
      } else {
        data = await ListFunctions.fetchData(options);
      }
      const csvContent = await this.buildCSV(data.data);
      await this.openCSV(csvContent);
      await Help.sleep(600);
      this.setState({
        currentlyDownloading: false
      });
    };
    this.buildCSV = data => {
      const columns = this.getColumns();
      const filtered_columns = columns.filter(c => c.csvShow === true || c.show !== false && c.csvShow !== false);
      const headers = filtered_columns.map(c => "\"".concat(c.csvHeader || c.Header, "\""));
      const fields = filtered_columns.map(c => c.csvField || c.accessor);
      const csvData = data.map(d => fields.map(c => {
        let value = '';
        if (typeof c !== 'function') {
          const field = (c || '').toString().split('.');
          if (field.length == 1) {
            value = d[field[0]];
          } else if (field.length == 2) {
            value = d[field[0]][field[1]];
          }
          value = value === 0 ? '0' : (value || '').toString();
        } else {
          value = c(d);
        }
        return "\"".concat(this.replaceQuotes(value), "\"");
      }).join(',')).join('\n');
      const content = "".concat(headers.join(','), "\n").concat(csvData);
      return "data:text/csv;charset=utf-8,".concat(encodeURIComponent(content));
    };
    this.replaceQuotes = str => str.toString().replace(/\"/g, '""');
    this.getCsvFilename = () => "".concat(this.getPageTitle(), " - ").concat(new Moment().format('YYYY-MM-DD hh:mm a'), ".csv");
    this.openCSV = csvContent => {
      const link = document.createElement('a');
      link.setAttribute('href', csvContent);
      link.setAttribute('download', this.getCsvFilename());
      document.body.appendChild(link);
      link.click();
    };
    this.additionalFormProps = () => ({});
    this.getForm = () => {
      const TagName = this.getFormTag();
      return /*#__PURE__*/React.createElement(TagName, {
        userGroups: this.state.userGroups,
        data: this.state.data,
        type: this.state.type,
        editItem: this.state.selectedItem,
        showModal: this.state.showModal,
        closeModal: this.handleCloseModal,
        updateData: this.updateData,
        englishLanguageUuid: this.state.englishLanguageUuid,
        additionalFormProps: this.additionalFormProps()
      });
    };
    this.basicTable = () => /*#__PURE__*/React.createElement(WmReactTable, {
      canDownloadCsv: this.canDownloadCsv(),
      className: this.getTableClassSettings(),
      columns: this.getColumns(),
      currentlyDownloading: this.state.currentlyDownloading,
      data: this.state.data,
      downloadCsv: this.fetchCsvData,
      filtered: this.state.filtered,
      getTrProps: this.getTrProps,
      innerRef: this.innerTableRef,
      loading: this.state.loading,
      pageSize: this.props.pageSize,
      pageSizeOptions: this.props.pageSizeOptions,
      ref: this.tableRef
    });
    this.paginationTable = () => /*#__PURE__*/React.createElement(WmReactTableServerSide, {
      ref: this.tableRef,
      innerRef: this.innerTableRef,
      className: this.getTableClassSettings(),
      pages: this.state.pages,
      data: this.state.data,
      loading: this.state.loading,
      columns: this.getColumns(),
      onFetchData: debounce(this.fetchData, 2000),
      filtered: ListFunctions.getFiltered(this.getStorageName()),
      onFilteredChange: filtered => this.setState(ListFunctions.onFilteredChange(this.getStorageName(), filtered)),
      sorted: ListFunctions.getSorted(this.getStorageName()),
      onSortChange: sorted => ListFunctions.onSortChange(this.getStorageName(), sorted),
      resetFilters: () => ListFunctions.resetFilters(this.getStorageName(), this.tableRef),
      downloadCsv: this.fetchCsvData,
      canDownloadCsv: this.canDownloadCsv(),
      currentlyDownloading: this.state.currentlyDownloading,
      pageSize: this.props.pageSize,
      pageSizeOptions: this.props.pageSizeOptions,
      getTrProps: this.getTrProps
    });
    this.itemForm = () => this.state.showModal && (this.isAddAdmin() || this.isEditAdmin()) ? this.getForm() : /*#__PURE__*/React.createElement("div", null);
    this.handleCloseModal = function () {
      let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      _this.setState({
        ["showModal".concat(type)]: false,
        ["selectedItem".concat(type)]: null
      });
    };
    this.handleOpenModal = function (selectedItem) {
      let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _this.setState({
        ["showModal".concat(type)]: true,
        ["selectedItem".concat(type)]: selectedItem,
        ["selectedOptions".concat(type)]: opts
      });
    };
    this.updateData = () => {
      this.setState({
        showModal: false,
        selectedItem: null,
        loading: true
      });
      this.refreshAfterUpdate();
    };
    this.createButton = () => /*#__PURE__*/React.createElement("div", null, this.getFormTag() === '' ? '' : /*#__PURE__*/React.createElement(AddIcon, {
      className: "otto__margin_btm_30",
      onClick: this.handleOpenModal,
      addText: this.getAddText()
    }));
    this.createButtonSmall = () => /*#__PURE__*/React.createElement("div", null, this.getFormTag() === '' ? '' : /*#__PURE__*/React.createElement(AddIcon, {
      className: "btn-sm",
      onClick: this.handleOpenModal,
      addText: this.getAddText()
    }));
    this.sharedNameColumns = function () {
      let showInactiveLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return [{
        Header: 'Name',
        accessor: 'name',
        className: 'text-left'
      }, showInactiveLabel ? ColumnHelpers.activeInactiveColumn() : ColumnHelpers.activeColumn(), ColumnHelpers.auditLogLink(_this), ColumnHelpers.columnEditButton(_this)];
    };
    this.openAuditLogModal = uuid => this.setState({
      auditLogModalOpen: true,
      auditLogUuid: uuid
    });
    this.closeAuditLogModal = () => this.setState({
      auditLogModalOpen: false,
      auditLogUuid: null
    });
    this.auditLogModal = () => this.state.auditLogModalOpen ? /*#__PURE__*/React.createElement(AuditLogModal, {
      auth: this.props.auth,
      showModal: this.state.auditLogModalOpen,
      closeModal: this.closeAuditLogModal,
      modelType: this.auditLogModelType(),
      modelUuid: this.state.auditLogUuid
    }) : '';
  }
  async componentDidMount() {
    this.loadOnMount();
    const userInfo = await UserGroups.UserInfo(this.props.auth);
    if (this.props.setUserInfo !== undefined) {
      this.props.setUserInfo(userInfo);
    }
    await this.setState({
      userGroups: userInfo.groups,
      englishLanguageUuid: userInfo.englishLanguageUuid
    });
  }
  render() {
    return this.getContent();
  }
}